import React from "react";
import Layout from "@hoc/layouts/Layout";
import CountriesIndex from "@components/Country/CountriesIndex";

const CountriesPage = () => {
  return (
    <Layout>
      <CountriesIndex/>
    </Layout>
  );
};

export default CountriesPage;